module.exports = __webpack_public_path__ + "static/media/eduTechImg1.4bd266a0.jpg";